/* AGM · Home v2 (2) — flechas de la cinta de favoritos.
   26-sep-2026: los enlaces «Interactivo» de Míralos en acción y los dibujos de línea del catálogo ya vienen del servidor (sections/agm-home con
   snippets/agm-motivos); se quitó la parte que los copiaba a las fichas antiguas del catálogo, que ya no existen. */
(function(){
  /* Cinta de favoritos: flechas siempre disponibles; se desactivan al llegar al inicio / final. */
  [].forEach.call(document.querySelectorAll('.pstrip-wrap'), function(w){
    var s = w.querySelector('.pstrip'); if(!s) return;
    var p = w.querySelector('.pnav.prev'), n = w.querySelector('.pnav.next');
    var go = function(d){ s.scrollBy({ left: d * Math.max(240, s.clientWidth * .8), behavior: 'smooth' }); };
    var upd = function(){
      var max = s.scrollWidth - s.clientWidth - 4;
      if(p) p.disabled = s.scrollLeft < 4;
      if(n) n.disabled = s.scrollLeft >= max;
    };
    if(p) p.addEventListener('click', function(){ go(-1); });
    if(n) n.addEventListener('click', function(){ go(1); });
    s.addEventListener('scroll', upd, { passive: true });
    addEventListener('resize', upd, { passive: true });
    upd(); setTimeout(upd, 600);
  });

})();